export type DateRangeMode = "within" | "before" | "after"

export type DateRangeValue = {
  mode: DateRangeMode
  start?: string
  end?: string
  label?: string
}

export function isDateRangeValue(value: unknown): value is DateRangeValue {
  if (typeof value !== "object" || value === null) return false
  const obj = value as Record<string, unknown>
  return obj.mode === "within" || obj.mode === "before" || obj.mode === "after"
}
